const DB_NAME = 'ac-logs';
const STORE_NAME = 'logs';
const MAX_LOGS = 200;

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE_NAME, { autoIncrement: true });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function getLogs(): Promise<Record<string, unknown>[]> {
  const db = await openDB();
  return new Promise((resolve) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const req = tx.objectStore(STORE_NAME).getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => resolve([]);
  });
}

export async function addLog(entry: Record<string, unknown>): Promise<void> {
  const db = await openDB();
  await new Promise<void>((resolve) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    const store = tx.objectStore(STORE_NAME);

    const countReq = store.count();
    countReq.onsuccess = () => {
      if (countReq.result >= MAX_LOGS) {
        // Remove the oldest entry (lowest autoIncrement key)
        const cursorReq = store.openCursor();
        cursorReq.onsuccess = () => {
          cursorReq.result?.delete();
        };
      }
      store.add({ ...entry, timestamp: new Date().toISOString() });
    };

    tx.oncomplete = () => resolve();
    tx.onerror = () => resolve();
  });
}
